import {appFetch, AppFetchResponse} from "../utils/appFetch";

const getCountryDomesticMessagePrices = (locale: string, selectedDomain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `communication-provider/domestic-message-cost`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
        params: {
            locale
        },
    });
}

export default getCountryDomesticMessagePrices;